import React from 'react';

import Textfield from '@atlaskit/textfield/text-field';

export default function TextFieldAppearanceStandard(): React.JSX.Element {
	return <Textfield appearance="standard" label="Standard" placeholder="" />;
}
